import { Component, OnInit, Input } from '@angular/core';
import { CNPatient } from 'src/app/models/cnpatient';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-medical',
  templateUrl: './patient-medical.component.html',
  styleUrls: ['./patient-medical.component.scss']
})
export class PatientMedicalComponent extends PatientComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  doctorSelected(event) {
    console.log('doctor selected', event);
  }
}
